import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import "./MechanicApproval.css";

export default function MechanicApproval() {
  const [unverifiedMechanics, setUnverifiedMechanics] = useState([]);
  const [loading, setLoading] = useState(false);
  const [approving, setApproving] = useState({});
  const [toast, setToast] = useState("");

  useEffect(() => {
    fetchUnverifiedMechanics();
  }, []);

  async function fetchUnverifiedMechanics() {
    setLoading(true);
    try {
      // Fetch ALL mechanics (verified and unverified) for debugging
      const { data, error } = await supabase
        .from("mechanics")
        .select("*")
        .order("created_at", { ascending: false });

      if (error) throw error;
      
      console.log("📊 All mechanics in database:", data);
      
      // Show only unverified, but log all
      const unverified = (data || []).filter(m => !m.is_verified);
      setUnverifiedMechanics(unverified);
      
      if (data?.length === 0) {
        setToast("⚠️ No mechanics at all in database!");
      } else if (unverified.length === 0) {
        setToast(`ℹ️ Found ${data.length} verified mechanics, 0 pending`);
      }
    } catch (err) {
      setToast(`Error loading mechanics: ${err.message}`);
      console.error("❌ Database error:", err);
    } finally {
      setLoading(false);
    }
  }

  async function approveMechanic(mechanicId) {
    setApproving((prev) => ({ ...prev, [mechanicId]: true }));
    try {
      const { error } = await supabase
        .from("mechanics")
        .update({ is_verified: true })
        .eq("id", mechanicId);

      if (error) throw error;

      setToast("✅ Mechanic approved!");
      setUnverifiedMechanics((prev) =>
        prev.filter((m) => m.id !== mechanicId)
      );

      setTimeout(() => setToast(""), 3000);
    } catch (err) {
      setToast(`❌ Error: ${err.message}`);
    } finally {
      setApproving((prev) => ({ ...prev, [mechanicId]: false }));
    }
  }

  async function rejectMechanic(mechanicId) {
    if (!window.confirm("Delete this mechanic permanently?")) return;

    try {
      const { error } = await supabase
        .from("mechanics")
        .delete()
        .eq("id", mechanicId);

      if (error) throw error;

      setToast("❌ Mechanic deleted");
      setUnverifiedMechanics((prev) =>
        prev.filter((m) => m.id !== mechanicId)
      );
    } catch (err) {
      setToast(`Error: ${err.message}`);
    }
  }

  if (loading) return <div className="approval-page">Loading...</div>;

  return (
    <div className="approval-page">
      <div className="approval-container">
        <h1>Mechanic Approval Panel</h1>

        {toast && <div className="approval-toast">{toast}</div>}

        {unverifiedMechanics.length === 0 ? (
          <p className="no-mechanics">✅ All mechanics are approved!</p>
        ) : (
          <div className="mechanics-list">
            {unverifiedMechanics.map((mechanic) => (
              <div key={mechanic.id} className="mechanic-card">
                <h3>{mechanic.name}</h3>
                <p><strong>Shop:</strong> {mechanic.shop_name}</p>
                <p><strong>Phone:</strong> {mechanic.phone_whatsapp}</p>
                <p>
                  <strong>Location:</strong> {mechanic.village}, {mechanic.district}, {mechanic.state}
                </p>
                <p><strong>Specialization:</strong> {mechanic.specialization.join(", ")}</p>
                <p><strong>Services:</strong> {mechanic.services.join(", ")}</p>
                <p><strong>Submitted:</strong> {new Date(mechanic.created_at).toLocaleDateString()}</p>

                <div className="action-buttons">
                  <button
                    className="btn-approve"
                    onClick={() => approveMechanic(mechanic.id)}
                    disabled={approving[mechanic.id]}
                  >
                    {approving[mechanic.id] ? "Approving..." : "✅ Approve"}
                  </button>
                  <button
                    className="btn-reject"
                    onClick={() => rejectMechanic(mechanic.id)}
                  >
                    ❌ Reject
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
